import AccountController from './account/AccountController';
import LessonsController from './lessons/LessonsController';
import { createElement } from 'react';
import { Navigate } from 'react-router-dom';

export const ClientRoutes = [
    {
        index: true,
        element: createElement(Navigate, { to: '/panel/lekcje', replace: true }),
    },
    {
        path: '/panel/lekcje',
        Component: LessonsController
    },
    {
        path: '/panel/konto',
        Component: AccountController
    },
    // {
    //     path: '/panel/regulaminy',
    //     Component: DocumentsController
    // }
]